import { configureStore } from "@reduxjs/toolkit";
import HomeReducer from "./Slice/Homepage";
import authReducer from "./Slice/Auth";
import partyCallReducer from "./Slice/Partycalldetails";
import projectReducer from "./Slice/TaskMasterSlice";
import SubTaskSlice from "./Slice/SubTask";
import AddCustomerSlice from "./Slice/AddCustomer";
import ShowAllTaskReducer from "./Slice/ShowAllTask";
import MemberSlice from "./Slice/AddMember";
import PayrollSlice from "./Slice/Payroll";
import Dayslice from "./Slice/Day";
import VersionSlice from "./WhatsappSlice/Version";
import ProjectSlice from "./WhatsappSlice/Project";
import LogReportSlice from "./WhatsappSlice/LogReport";
import ClientSlice from "./WhatsappSlice/Client";
import ExeRegistrationSlice from "./WhatsappSlice/ExeRegistration";
import SlabSlice from "./WhatsappSlice/Slab";
import TemplateSlice from "./WhatsappSlice/Template";
import WpApiSetupSlice from "./WhatsappSlice/WhatsappApiSetup";
import DocumentLinkSetupSlice from "./WhatsappSlice/DocumentLinkSetup";
import WpRegistrationSlice from "./WhatsappSlice/WhatsAppRegistration";
import DataTransferSlice from "./WhatsappSlice/DataTransfer";
import GeminiOcrSlice from "./GeminiOCRSlice/GeminiOCR";
import RequestServiceSlice from "./Slice/RequestServicesSlice";
import DbExeUpdateSlice from "./Slice/DbExeUpdate";
import LeaveFormReducer from "./Slice/LeaveForm";
import AttendanceCorrectionReducer from "./Slice/AttendanceCorrection";
import EinvoiceEwayBillReducer from "./Einvoice&EwayBillSlice/Einvoice&EwayBill";
import NotificationReducer from "./Slice/NotificationSlice";
import GeoResolverSlice from "./WhatsappSlice/GeoResolver";
import chatReducer from "./Slice/ChatSlice";
import tableManagementReducer from "./Slice/TableManagementSlice";

export const store = configureStore({
  reducer: {
    Home: HomeReducer,
    auth: authReducer,
    chat: chatReducer,
    partyCall: partyCallReducer,
    TaskMaster: projectReducer,
    SubTask: SubTaskSlice,
    AddCustomer: AddCustomerSlice,
    ShowAllTask: ShowAllTaskReducer,
    AddMemberSlice: MemberSlice,
    Payroll: PayrollSlice,
    Day: Dayslice,
    RequestService: RequestServiceSlice,

    // Table Management Slice (Projects, Types, Modules, Tables Master)
    TableManagement: tableManagementReducer,

    // Whatsapp Slice
    Client: ClientSlice,
    DataTransfer: DataTransferSlice,
    WpLogReport: LogReportSlice,
    WpRegistration: WpRegistrationSlice,
    WpApiSetup: WpApiSetupSlice,
    DocumentLinkSetup: DocumentLinkSetupSlice,
    Slab: SlabSlice,
    Template: TemplateSlice,
    ExeRegistration: ExeRegistrationSlice,
    Version: VersionSlice,
    Project: ProjectSlice,

    // Gemini OCR Slice
    GeminiOCR: GeminiOcrSlice,

    // Leave Form Slice
    DbExeUpdate: DbExeUpdateSlice,
    LeaveForm: LeaveFormReducer,
    AttendanceCorrection: AttendanceCorrectionReducer,

    // Einvoice&EwayBill Slice
    EinvoiceEwayBill: EinvoiceEwayBillReducer,
    Notification: NotificationReducer,

    // GeoResolver Slice
    GeoResolver: GeoResolverSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
